import React from 'react';

import {Ref} from '../util.js';


export default function() {
    return <>
        <p>How do you average (or sum) a lot of numbers, quickly?</p>
        <p>More precisely, how do you do this on a webpage, preferably in real-time, when your values are stored as pixels in a large image? In general-purpose applications, we have access to the massive parallelization capabilities of GPUs with CUDA or OpenCL — but on the web, we’re stuck with WebGL and fragment shaders.</p>
        <p>One possibility is to write a fragment shader that repeatedly downscales the image by a factor of 2, where each output pixel is the average of the four pixels in its preimage. Assuming each render takes constant time due to GPU parallelization,<Ref id={1}/> this technique can average an \(n \times n\) texture in {'\\(\\log_2{n}\\)'} time.</p>
    </>;
}
